import * as React from 'react'
import type { VariantProps } from 'class-variance-authority'
import { cn } from '@utils/helpers'
import { typographyVariants } from './Typography.variants'

const typeToElement: Record<string, keyof JSX.IntrinsicElements> = {
  heading: 'h2',
  body: 'p',
  label: 'span',
  caption: 'span',
  overline: 'span',
  link: 'a'
}

type TypographyProps = VariantProps<typeof typographyVariants> & {
  className?: string
  children?: React.ReactNode
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div' | 'a'
} & Omit<React.HTMLAttributes<HTMLElement>, 'className' | 'children'> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

export const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  ({ className, type = 'body', size, as, children, ...props }, ref) => {
    const Component = as || typeToElement[type || 'body'] || 'p'

    return React.createElement(
      Component,
      { ref, className: cn(typographyVariants({ type, size }), className), ...props },
      children
    )
  }
)
Typography.displayName = 'Typography'
